import { User } from "../../users/users.model";

export class RoleClaim {
    namespaceEntry: string;
    name: string;
    canAdd: boolean;
    canShow: boolean;
    canEdit: boolean;
    canDelete: boolean;
}

export class RoleNavigationElement {
    id: number;
    name: string;
    isVisible: boolean;
    parentId: number;
    childElements: RoleNavigationElement[];
}

export class Role {
    guid: string;
    roleName: string;
    roleClaims: RoleClaim[];
    navigationElements: RoleNavigationElement[];
    hasBudgetPermission: boolean;
    hasAllWorklogsPermission: boolean;
    hasIssuesNotAssignedPermission: boolean;
    hasIsToTfsPermission: boolean;
    hasCustomerBlockingPermission: boolean;
    hasExtIssuesRcpReportPermission: boolean;
    hasExtIssuesRcpReportForeignPayerPermission: boolean;
}